import React from "react";
import "./stick.style.scss";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Stick({
  color = "#cbaa6f",
  data = {},
  disabled = false,
  onClick,
}) {
  const formatFullDate = (date) => {
    if (!date) return "";
    const d = dayjs.utc(date);
    return d.format("ddd, MMM D, YYYY");
  };

  const formatTime = (date) => {
    if (!date) return "";
    return dayjs.utc(date).format("h:mm A");
  };

  const hasUsage = data.cups && data.cups.length > 0;
  const totalCostValue = Number(data.total_cost || 0);
  const totalCost = totalCostValue.toFixed(2);

  return (
    <div className="stick-container" onClick={!disabled && onClick}>
      <div className="stick-wrapper">
        <div className="heading">
          <div className="client">{data.client}</div>
          {data.date && dayjs(data.date).isValid() && (
            <div className="date">
              <div className="date-label">Last Transaction</div>
              <div className="date-value">{formatFullDate(data.date)}</div>
            </div>
          )}
        </div>
        <div className="usage-body">
          {hasUsage ? (
            <ul style={{ "--timeline-color": color }}>
              {data.cups.map((cup, i) => (
                <li key={i} className="resources">
                  <div className="timeline-node">
                    <span />
                  </div>
                  <div className="cup">
                    <div className="cup-name">
                      <span>{cup.name}</span>
                      {cup.time && dayjs(cup.time).isValid() && (
                        <span className="cup-time">{formatTime(cup.time)}</span>
                      )}
                    </div>
                    <div className="resource">
                      {cup.resources.map((item, index) => (
                        <div key={index} className="resource-item">
                          <span className="resource-name">{item.name}</span>
                          <span
                            className={`resource-amount ${
                              item.amount != null && item.amount > 0
                                ? "recorded"
                                : "missing"
                            }`}
                          >
                            {item.amount != null && item.amount > 0
                              ? `${item.amount}g`
                              : "No amount"}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="empty-usage">No colors recorded.</div>
          )}
        </div>
      </div>
      <div className="summary">
        <div>TOTAL cost:</div>
        <div
          className={`summary-amount ${
            totalCostValue > 0 ? "has-cost" : "no-cost"
          }`}
        >
          ${totalCost}
        </div>
      </div>
    </div>
  );
}
